(function () {
  'use strict';

  function initFeaturedCollection() {
    var section = document.querySelector('.by-featured-collection');
    if (!section) return;

    section.querySelectorAll('.by-fc__add-to-cart, .by-fc__cart-circle').forEach(function (btn) {
      // Prevent attaching duplicate listeners
      if (btn.dataset.fcInitialized) return;
      btn.dataset.fcInitialized = 'true';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        handleCartAction(btn);
      });
    });
  }

  function handleCartAction(btn) {
    var hasVariants = btn.dataset.hasVariants === 'true';
    var productUrl  = btn.dataset.productUrl;
    var variantId   = btn.dataset.variantId;

    // Products with multiple variants → go to product page for selection
    if (hasVariants) {
      window.location.href = productUrl;
      return;
    }

    if (!variantId) return;

    var isBarBtn     = btn.classList.contains('by-fc__add-to-cart');
    var originalText = btn.textContent;

    btn.disabled = true;
    if (isBarBtn) btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (isBarBtn) btn.textContent = 'Added!';

        // Re-fetch cart to get updated count for badge
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        // Notify by-header.js cart badge listener
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { item_count: cart.item_count }
        }));

        setTimeout(function () {
          btn.disabled = false;
          if (isBarBtn) btn.textContent = originalText;
        }, 1500);
      })
      .catch(function () {
        btn.disabled = false;
        if (isBarBtn) btn.textContent = originalText;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCollection);
  } else {
    initFeaturedCollection();
  }

  // Re-init on Shopify theme editor section reload
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.by-featured-collection')) {
      // Reset init flags so listeners can be re-attached on new DOM
      e.target.querySelectorAll('[data-fc-initialized]').forEach(function (el) {
        delete el.dataset.fcInitialized;
      });
      initFeaturedCollection();
    }
  });

})();
